function ForgotEmail({ handleEmailChange, handleEmailSubmit, emailForm, formErrors}) {

  return (
    <>
      <form onSubmit={handleEmailSubmit} className="sign-up-form">
        <label className="label-forgot-email">What is your email?</label>
        {emailForm.email ?
          <span className="su-errors">{formErrors.email}</span>
        : null}
        <input 
          className="sign-up-form-input"
          type="text" 
          name="email" 
          placeholder="Email" 
          onChange={handleEmailChange} 
          value={emailForm.email} 
        />             
        
        <button className="sign-up-submit-button" onClick={handleEmailSubmit}>Submit</button>
      </form>
    </>
  )
}

export default ForgotEmail
